export class DvirGroupDto {
  id: number;
  title: string;
  hasRemarks: boolean;

  constructor(id: number, title: string, hasRemarks: boolean) {
    this.id = id;
    this.title = title;
    this.hasRemarks = hasRemarks;
  }
}
